import React from "react";
import { motion } from "framer-motion";
import { ShieldCheck, BadgeCheck, Clock4, Sparkles } from "lucide-react";
import { SITE } from "@/data/site";

const iconMap = [BadgeCheck, ShieldCheck, Clock4, Sparkles];

export default function Guarantee() {
  return (
    <section
      data-testid="guarantee-section"
      className="relative bg-black py-24 lg:py-32 border-t border-brand-border"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="text-xs uppercase tracking-[0.3em] text-brand-accent">
              Naše záruka
            </div>
            <h2 className="mt-4 font-display font-black text-4xl lg:text-6xl leading-[1.05] tracking-tight">
              {SITE.guarantee.title.split(".")[0]}
              <span className="italic font-light text-brand-accent">.</span>
            </h2>
            <p className="mt-6 text-brand-muted leading-relaxed max-w-md">
              {SITE.guarantee.sub}
            </p>
            <a
              href="#reservation"
              data-testid="guarantee-cta"
              className="mt-8 inline-flex items-center gap-3 bg-brand-accent text-black font-semibold px-7 py-4 hover:bg-brand-accentHover transition-all group"
            >
              Odeslat poptávku
              <span className="transition-transform group-hover:translate-x-1.5">→</span>
            </a>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-px bg-brand-border">
            {SITE.guarantee.points.map((p, i) => {
              const Icon = iconMap[i] || ShieldCheck;
              return (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-80px" }}
                  transition={{ duration: 0.5, delay: i * 0.08 }}
                  className="bg-black p-7 group hover:bg-brand-surface transition-colors"
                >
                  <div className="w-11 h-11 border border-brand-border flex items-center justify-center text-brand-accent group-hover:border-brand-accent transition-colors">
                    <Icon size={20} />
                  </div>
                  <h3 className="mt-5 font-display font-bold text-lg">{p.title}</h3>
                  <p className="mt-2 text-sm text-brand-muted leading-relaxed">{p.text}</p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
